<template>
  <match-media v-slot="{ mobile }">
    <div class="v-image-preview">
      <span class="v-image-preview__photo" :style="{ backgroundImage: `url(${image})` }">
        <template v-if="!loading">
          <template v-if="editable">
            <span v-if="!mobile" class="v-image-preview__photo-button" @click="onPhotoClick">
              <v-icon-filters />
            </span>
            <span v-else class="v-image-preview__photo-button-mobile" @click="onPhotoClick">
              <v-icon-edit />
            </span>
          </template>
          <template v-else>
            <span v-if="!mobile" class="v-image-preview__photo-button" @click="removeImage">
              <v-icon-basket />
            </span>
            <span v-else class="v-image-preview__photo-button-mobile" @click="removeImage">
              <v-icon-cross />
            </span>
          </template>
        </template>

        <span v-else class="v-image-preview__loader-wrapper">
          <span class="v-image-preview__loader-track">
            <span class="v-image-preview__loader" :style="{ width: `${progress * 100}%` }"></span>
          </span>
        </span>
      </span>
    </div>
  </match-media>
</template>

<script>
import { MatchMedia } from 'vue-component-media-queries'
import VIconFilters from '@/components/icons/VFilters.vue'
import VIconEdit from '@/components/icons/Vedit.vue'
import VIconCross from '@/components/icons/VCross.vue'
import VIconBasket from '@/components/icons/VBasket.vue'

export default {
  name: 'VImagePreview',
  components: { VIconCross, VIconBasket, VIconEdit, VIconFilters, MatchMedia },
  inheritAttrs: false,
  props: {
    image: { type: String, required: true },
    progress: { type: Number, default: undefined },
    editable: { type: Boolean, default: false }
  },
  computed: {
    loading() {
      return this.progress !== undefined
    }
  },
  methods: {
    onPhotoClick() {
      this.$emit('edit')
    },
    removeImage() {
      this.$emit('remove')
    }
  }
}
</script>
